export default __webpack_public_path__ + "static/media/kf-avatar.70eec69e.png";